<template>
  <div>
    <PageHeader :schema="$schemas.natureOperation" />
    <PageContent>
      <DynamicFormPage
        :schema="$schemas.natureOperation"
        :service="$api.natureOperations"
      />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateNatureOperation',
  components: { PageHeader, PageContent, DynamicFormPage },
  data() {
    return {};
  },
};
</script>
